// extracted by mini-css-extract-plugin
export var copyBlock = "copyBlockOptionalImage-module--copy-block--8Bx2a";
export var copyWithImage = "copyBlockOptionalImage-module--copy-with-image--3EUZY";